import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomizedButton = styled(Button)<ButtonProps>(() => ({
  "&.MuiButton-root": {
    textTransform: "initial",
    height: 56,
    fontWeight: "400",
    borderRadius: 100,
    border: "1.6px solid #5D26C5",
    fontSize: 20,
    "&.MuiButton-text": {
      color: "#5D26C5",
      "&:active": {
        backgroundColor: "#5D26C5",
        color: "#ffffff",
      },
      "&.Mui-disabled": {
        color: "#191C1D",
        opacity: 0.38,
      },
    },
  },
}));

interface Props {
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | (() => void);
  testId?: string;
  className?: string;
  type?: "submit" | "reset" | "button";
  id?: string;
}

export const CustomButtonOutline = (props: Props) => {
  const {
    label,
    disabled,
    fullWidth,
    style,
    onClick,
    testId,
    className,
    type,
    id,
  } = props;

  return (
    <CustomizedButton
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      className={className}
      type={type}
      id={id}
      disableRipple
      style={style}
      data-testid={testId}
    >
      {label}
    </CustomizedButton>
  );
};
